<a
  (click)="navigate.emit()"
  [attr.aria-label]="text()"
  [class]="hideTextClass()"
  [href]="href()"
  class="button"
  wlTrackLink
  [trackLinkInfo]="{ type: 'navigation', field: text() }"
>
  <fa-icon
    [fixedWidth]="true"
    [icon]="iconName()"
    class="button__icon align-self-center"
  />
  <span class="button__text">{{ text() }}</span>
</a>
